"use client"

import { motion } from "framer-motion"
import { Shield, Eye, Lock, FileText, HelpCircle, Users, Database, Scale } from "lucide-react"
import "../styles/QuemSomos.css" // Utilizando o mesmo CSS base

const PoliticaPrivacidade = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 },
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="quem-somos-container"
    >
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="titulo"
      >
        <Shield className="titulo-icon" />
        Política de Privacidade
      </motion.h1>

      <div className="conteudo">
        <motion.p {...fadeIn} transition={{ duration: 0.5, delay: 0.3 }}>
          Seja bem-vindo ao <strong>Ticket do Vaqueiro</strong>! Esta Política de Privacidade foi elaborada com base em nossos valores de transparência, segurança e respeito aos seus dados pessoais. Levamos sua privacidade a sério e adotamos medidas para protegê-la.
          Ao utilizar nossa plataforma, alguns dados poderão ser coletados, tanto pessoais quanto não pessoais. Ao acessar e utilizar o Ticket do Vaqueiro, você declara que leu, compreendeu e concorda com esta Política.
        </motion.p>

        {/* 1. Glossário */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.4 }} className="secao-politica">
          <h3><FileText size={20} /> 1. Glossário</h3>
          <ul className="politica-lista">
            <li><strong>Vaqueiro:</strong> pessoa que adquire senhas para participar de vaquejadas.</li>
            <li><strong>Cookies:</strong> arquivos que permitem identificar preferências e melhorar a navegação.</li>
            <li><strong>Dados Pessoais:</strong> informações que identificam ou podem identificar uma pessoa natural.</li>
            <li><strong>Organizador:</strong> quem utiliza a plataforma para divulgar eventos e vender senhas.</li>
            <li><strong>Tratamento de dados:</strong> qualquer operação realizada com dados pessoais (coleta, armazenamento, uso).</li>
          </ul>
        </motion.div>

        {/* 2. Coleta */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.5 }} className="secao-politica">
          <h3><Eye size={20} /> 2. Coleta de informações</h3>
          <p>Coletamos dados fornecidos diretamente, como <strong>Nome, CPF, E-mail, Telefone e Endereço</strong>. Também coletamos dados automáticos de navegação (IP, navegador) e informações de processadores de pagamento e parceiros de segurança.</p>
        </motion.div>

        {/* 3. Uso */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.6 }} className="secao-politica">
          <h3><Database size={20} /> 3. Uso das informações</h3>
          <p>Os dados são utilizados para operar a plataforma, processar compras, garantir segurança e realizar análises. O tratamento é feito com base na <strong>LGPD (Lei nº 13.709/2018)</strong>.</p>
        </motion.div>

        {/* 4. Compartilhamento */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.7 }} className="secao-politica">
          <h3><Users size={20} /> 4. Compartilhamento de dados</h3>
          <p>O Ticket do Vaqueiro <strong>não vende dados pessoais</strong>. O compartilhamento ocorre apenas com organizadores de eventos, prestadores de serviços tecnológicos/financeiros e autoridades legais.</p>
        </motion.div>

        {/* 5. Segurança */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.8 }} className="secao-politica">
          <h3><Lock size={20} /> 5. Armazenamento e segurança</h3>
          <ul className="politica-lista">
            <li><span className="bullet">•</span> Criptografia e monitoramento contínuo.</li>
            <li><span className="bullet">•</span> Controle de acesso rigoroso.</li>
            <li><span className="bullet">•</span> Dados mantidos apenas pelo tempo necessário legal.</li>
          </ul>
        </motion.div>

        {/* 6. Direitos */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.9 }} className="secao-politica">
          <h3><Scale size={20} /> 6. Direitos do usuário</h3>
          <p>Você tem total controle sobre suas informações. A qualquer momento, você pode solicitar o acesso, a correção, a portabilidade ou a exclusão definitiva da sua conta e de todos os seus dados pessoais.</p>
          <p>A exclusão de conta pode ser solicitada diretamente dentro do aplicativo (na área de configurações/perfil) ou entrando em contato através do nosso suporte oficial.
Dúvidas sobre privacidade ou solicitação de exclusão?</p>
        </motion.div>

        {/* 10. Contato */}
        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 1.0 }} className="contact-info">
          <HelpCircle size={20} className="contact-icon" />
          <p>Dúvidas sobre privacidade? Contacte-nos em: <strong>contato@ticketdovaqueiro.com</strong></p>
        </motion.div>

        <p style={{ textAlign: 'center', color: '#888', marginTop: '30px', fontSize: '12px' }}>
          Última atualização: Abril de 2026 | Cajazeiras – PB
        </p>
      </div>
    </motion.div>
  )
}

export default PoliticaPrivacidade